import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '@/api/client';
import { Field } from '@/components/ui/Field';
import leadStyles from '@/features/leads/Leads.module.css';

const STORAGE_PREFIX = 'mh-preview-lead';

type Props = {
  projectId: string;
  value: string;
  onChange: (leadId: string) => void;
  label?: string;
};

export function PreviewLeadPicker({ projectId, value, onChange, label = 'Voorbeeld-lead (preview)' }: Props) {
  const storageKey = `${STORAGE_PREFIX}:${projectId}`;

  const leadsQ = useQuery({
    queryKey: ['leads-preview-picker', projectId],
    enabled: Boolean(projectId),
    queryFn: () =>
      apiFetch<{ leads: { id: string; email: string | null; contact_name: string | null }[] }>(
        `/api/leads?project_id=${projectId}&page=1&page_size=100`,
      ),
  });

  const withEmail = (leadsQ.data?.leads ?? []).filter((l) => l.email);

  useEffect(() => {
    if (!projectId || value || !withEmail.length) return;
    try {
      const stored = sessionStorage.getItem(storageKey);
      if (stored && withEmail.some((l) => l.id === stored)) {
        onChange(stored);
        return;
      }
    } catch {
      /* ignore */
    }
    onChange(withEmail[0]!.id);
  }, [projectId, value, withEmail, storageKey, onChange]);

  return (
    <Field label={label}>
      <select
        className={leadStyles.filterInput}
        value={value}
        onChange={(e) => {
          onChange(e.target.value);
          try {
            sessionStorage.setItem(storageKey, e.target.value);
          } catch {
            /* ignore */
          }
        }}
      >
        <option value="">— kies lead —</option>
        {withEmail.map((l) => (
          <option key={l.id} value={l.id}>
            {l.contact_name ?? l.email} ({l.email})
          </option>
        ))}
      </select>
    </Field>
  );
}
